<template>
  <div class="w-full">
    <div v-if="isTitle" class="mb-12 flex w-full flex-col text-center md:mb-20">
      <p class="mb-3 text-sm font-medium uppercase tracking-wider text-primary">
        {{ $t('landing.pricing.sectionTitle') }}
      </p>
      <h2
        class="mx-auto text-4xl font-extrabold tracking-tight md:text-6xl text-gray-900"
      >
        {{ $t('landing.pricing.headline') }}
      </h2>
      <p class="mt-6 text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
        {{ $t('landing.pricing.subtitle') }}
      </p>
    </div>

    <div
      class="flex flex-col justify-center items-center gap-8 lg:flex-row lg:gap-12"
    >
      <div class="flex flex-col items-center w-full max-w-lg">
        <LandingPricingCard
          class="w-full"
          :title="$t('landing.pricing.cardTitle')"
          :subtitle="$t('landing.pricing.cardSubtitle')"
          :original-price="originalPriceDisplay"
          :price="displayPrice"
          :currency-label="displayCurrency"
          :price-approx="$t('landing.pricing.priceApprox')"
          :features="lifetimeFeatures"
          :is-loading="isLoadingLifetime"
          :is-popular="true"
          :button-text="$t('landing.pricing.buttonText')"
          @purchase="handleLifetimePurchase"
        />

        <!-- <div
          class="mt-10 flex flex-col items-center gap-6 border-t border-gray-100 pt-10"
        >
          <div class="flex items-center gap-2 text-gray-400">
            <BaseIcon icon="shield-check" class="text-sm" />
            <span class="text-[10px] font-bold uppercase tracking-[0.2em]"
              >Secure checkout powered by</span
            >
          </div>

          <div
            class="flex flex-wrap justify-center items-center gap-x-10 gap-y-6 opacity-60 grayscale transition-all duration-500 hover:opacity-100 hover:grayscale-0"
          >
            <div class="flex flex-col items-center gap-2 group">
              <img
                src="/icons/liqpay.png"
                alt="LiqPay"
                class="h-6 object-contain transition-transform group-hover:scale-110"
              />
              <span
                class="text-[9px] font-bold uppercase tracking-widest text-gray-400"
                >LiqPay</span
              >
            </div>
            <div class="flex flex-col items-center gap-2 group">
              <img
                src="/icons/privat24.png"
                alt="Privat24"
                class="h-6 object-contain transition-transform group-hover:scale-110"
              />
              <span
                class="text-[9px] font-bold uppercase tracking-widest text-gray-400"
                >Privat24</span
              >
            </div>
            <div class="flex flex-col items-center gap-2 group">
              <img
                src="/icons/apay.png"
                alt="Apple Pay"
                class="h-5 object-contain transition-transform group-hover:scale-110"
              />
              <span
                class="text-[9px] font-bold uppercase tracking-widest text-gray-400"
                >Apple Pay</span
              >
            </div>
            <div class="flex flex-col items-center gap-2 group">
              <div
                class="flex items-center gap-1 transition-transform group-hover:scale-110"
              >
                <img
                  src="/icons/google-logo.png"
                  alt="Google"
                  class="h-4 object-contain"
                />
                <span class="text-[10px] font-bold text-gray-900">Pay</span>
              </div>
              <span
                class="text-[9px] font-bold uppercase tracking-widest text-gray-400"
                >Google Pay</span
              >
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import LandingPricingCard from '@/components/Landing/LandingPricingCard.vue'

// 300,000+ exercises from 120+ English grammar topics
// Progress 30-50% faster than with standard tests
// 30-day money-back guarantee
// Love it or get your money back
// Secure payment Protected by Privat24 – LiqPay GooglePay, ApplePay, Paddle

// import services from '@/services'

export default {
  name: 'LandingPricing',

  components: { LandingPricingCard },

  props: {
    isTitle: { type: Boolean, default: true },
    isPaywall: { type: Boolean, default: false }
  },

  data() {
    return {
      isLoadingYear: false,
      isLoadingLifetime: false
    }
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('auth', ['isAuthorized']),
    ...mapGetters('locale', ['currentLocale']),
    ...mapGetters('user', ['isOnboarded']),
    ...mapGetters('pricing', ['priceUsd', 'priceUah']),

    displayPrice() {
      return this.currentLocale === 'uk' ? String(this.priceUah) : String(this.priceUsd)
    },
    displayCurrency() {
      return this.currentLocale === 'uk' ? 'грн' : '$'
    },
    originalPriceDisplay() {
      if (this.currentLocale === 'uk') {
        return `${Math.round(this.priceUah * 3)} грн`
      }
      return this.$t('landing.pricing.originalPrice')
    },

    lifetimeFeatures() {
      return [
        { icon: 'check', content: this.$t('landing.pricing.feature1') },
        { icon: 'check', content: this.$t('landing.pricing.feature2') },
        { icon: 'check', content: this.$t('landing.pricing.feature3') },
        { icon: 'check', content: this.$t('landing.pricing.feature4') },
        { icon: 'check', content: this.$t('landing.pricing.feature5') }
      ]
    }
  },

  mounted() {
    this.$store.dispatch('pricing/FETCH_PRICE')
  },

  methods: {
    ...mapActions('payments', {
      openCheckout: 'OPEN_CHECKOUT'
    }),

    // async handleYearlyPurchase() {
    //   if (this.isPaywall) {
    //     window?.datafast('checkout-opened', {
    //       plan: 'one-year-pass'
    //     })

    //     this.isLoadingYear = true
    //     await this.openCheckout('one-year-pass')
    //     this.isLoadingYear = false
    //     return
    //   }

    //   this.$router.push({
    //     name: 'signin.plan',
    //     params: { plan: 'one-year-pass' }
    //   })
    // },

    async handleLifetimePurchase() {
      if (this.user?.isPremium) {
        this.$router.push({ name: 'hub.sections' })
        return
      }

      if (this.isAuthorized) {
        window?.datafast('checkout-opened', {
          plan: 'lifetime-pass',
          price: 4
        })

        this.isLoadingLifetime = true
        await this.openCheckout('lifetime-pass')
        this.isLoadingLifetime = false
        return
      }

      this.$router.push({
        name: 'signin'
      })
      // this.$router.push({
      //   name: 'signin.plan',
      //   params: { plan: 'lifetime-pass' }
      // })
    }

    // async openCheckout(plan) {
    //   try {
    //     const { content } = await services.payments.liqpayCheckout({
    //       locale: this.currentLocale,
    //       plan
    //     })

    //     localStorage.setItem('pendingOrderId', content.orderId)

    //     // Redirect directly to payment gateway
    //     window.location.href = content.link
    //   } catch (e) {
    //     console.error('Failed to initiate checkout:', e)
    //     // alert(this.$t('payment.error.somethingWentWrong'))
    //   }
    // }
  }
}
</script>
